module.exports = __webpack_public_path__ + "static/img/intro1.f8d25fd0.png";